import Header from './components/Header';
import Hero from './components/Hero';
import Ranking from './components/Ranking';
import Cards from './components/Cards';
import AppSection from './components/AppSection';
import Features from './components/Features';
import Media from './components/Media';
import About from './components/About';
import Comments from './components/Comments';
import Topics from './components/Topics';
import FAQ from './components/FAQ';
import Carousel from './components/Carousel';
import Updates from './components/Updates';
import Contact from './components/Contact';
import Index from './components/Index';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Ranking />
        <Cards />
        <AppSection />
        <Features />
        <Media />
        <About />
        <Comments />
        <Topics />
        <FAQ />
        <Carousel />
        <Updates />
        <Contact />
        <Index />
      </main>
      <Footer />
    </>
  );
}